import { SERVER_URL } from '../../constants';

import {
  fetchGetAuth,
  fetchGetAuthBlob,
  fetchPostAuth,
  fetchPostAuthFile,
} from '../../util/FetchUtil';

const controller = 'instituicao/';

const findByHostname = (hostname) => {
  return fetch(SERVER_URL + controller + "hostname", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'no-cors'
    },
    body: hostname
  })
    .then((response) => {
      return response.json();
    });
}

export const save = (instituicao) => {
  const url = SERVER_URL + controller;
  return fetchPostAuth(url, instituicao);
}

export const saveMasterInstituicao = (instituicao) => {
  const url = SERVER_URL + controller + "save-master";
  return fetchPostAuth(url, instituicao);
}

export const downloadInstituicaoModelCSV = () => {
  const url = SERVER_URL + controller + "download?modelo=instituicao-modelo";
  return fetchGetAuthBlob(url);
}

const findByDescricao = (descricao) => {
  const url = SERVER_URL + controller + 'query?descricao=' + descricao
  return fetchGetAuth(url);
}

export const findInstituicaoAll = (page, size) => {
  const url = SERVER_URL + controller + 'query-page?page=' + page + '&size=' + size;
  return fetchGetAuth(url);
}

export const importInstituicaoFile = (fileInstitution) => {
  const url = SERVER_URL + controller + 'import-file';
  return fetchPostAuthFile(url, fileInstitution);
}

export {
  findByHostname,
  findByDescricao
}